import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import LanguageContext from "../components/hooks/LanguageContext";

const API_LANGUAGE_DETAIL = "language-detail";
const API_TRANSLATIONS = "static-translation";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Initial default languages (fallback if API fails)
const defaultLanguages = [
  {
    id: 1,
    language: "English",
    language_tag: "en",
    language_text_app: "A",
    language_tag_full: "english"
  }
];

// Provider
const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("english");
  const [languages, setLanguages] = useState(defaultLanguages);
  const [translations, setTranslations] = useState({});
  const [isLanguageLoading, setIsLanguageLoading] = useState(true);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/${API_LANGUAGE_DETAIL}`, {
          headers: {
            Accept: "application/json",
            "x-api-key": "fc9f4a47-4f7f-41ba-a656-d30e0009d6f0",
          },
        });

        if (response?.data?.success && response?.data?.languages) {
          setLanguages(response.data.languages);
          // Set default language to first available if current not in list
          const availableTags = response.data.languages.map(l => l.language_tag_full);
          if (!availableTags.includes(language)) {
            setLanguage(response.data.languages[0]?.language_tag_full || "english");
          }
        }
      } catch (error) {
        console.error("Failed to fetch languages:", error);
        // Keep default languages on error
      } finally {
        setIsLanguageLoading(false);
      }
    };

    const fetchTranslations = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/${API_TRANSLATIONS}`, {
          headers: {
            Accept: "application/json",
            "x-api-key": "fc9f4a47-4f7f-41ba-a656-d30e0009d6f0",
          },
        });

        if (response?.data?.success && response?.data?.translations) {
          setTranslations(response.data.translations);
        }
      } catch (error) {
        console.error("Failed to fetch translations:", error);
      }
    };

    fetchLanguages();
    fetchTranslations();
  }, []);

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage,
        languages,
        translations,
        isLanguageLoading,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook for new code
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export default LanguageProvider;
